import { render, staticRenderFns } from "./survey.vue?vue&type=template&id=0628d0f8&scoped=true&lang=pug&"
import script from "./survey.vue?vue&type=script&lang=ts&"
export * from "./survey.vue?vue&type=script&lang=ts&"
import style0 from "./survey.vue?vue&type=style&index=0&id=0628d0f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0628d0f8",
  null
  
)

export default component.exports